export const PAYIN_AUDIENCE_TYPES = {
  SCHOOL: 'school',
  WORK: 'work',
  PUBLIC: 'public',
};

export const PAYIN_SCHOOL_SEGMENTS = {
  PRIMARY: 'primary_school',
  NURSERY: 'nursery/early_years_setting',
  SECONDARY: 'secondary_school',
  COLLEGE: 'college_or_sixth_form',
  YOUTH_GROUP: 'youth_group',
};

export const JOURNEY_TYPES = {
  SINGLE: 'single',
  MONTHLY: 'monthly',
  PAYIN: 'payin',
  DIRECT: 'direct'
};

// Just the one, for now...
export const FULFILMENT_TYPES = {
  AARN: 'aarn',
};
